//@ts-nocheck
/**
 * This is a TypeGen auto-generated file.
 * Any changes made to this file can be lost when this file is regenerated.
 */

import { FeatureFlag } from "../FeatureFlag";

export const IgnoreIsFetchingAllForCacheExpiry: FeatureFlag = {"Id":"IgnoreIsFetchingAllForCacheExpiry","Label":"(QA)[10.27] Ignore cache minimum when computed cache for fetching all rows","Impact":"For QA. When active, FetchLinkTableDataSet computes the response-cache expiry (both the responseMaxAge min-bound and the default cache duration) purely from rowCount, ignoring isFetchingAll. When disabled, isFetchingAll continues to also trigger the longer cache tiers exactly as before.","Mode":1,"ActiveOn":null,"ActiveUntil":null,"GlobalEnabled":false,"TenantEnabled":null,"UserEnabled":null,"Scope":7};
